import { t } from "i18next";

import { Header } from "@/components/Header";
import { Networks } from "@/components/Networks";
import { ScrollSnapping } from "@/components/ScrollSnapping";
import { useStore } from "@/hooks/store";
import { useAirdrops } from "@/hooks/store/useAirdrops";
import { useLoadAirdrops } from "@/hooks/useLoadAirdrops";
import { statusOrder } from "@/interfaces/store";

import { Airdrop } from "./components/Airdrop";
import { EmptyNFTs } from "./components/EmptyNFTs";
import styles from "./styles";

export const Airdrops = () => {
  const { currentNetwork, user } = useStore((store) => ({
    currentNetwork: store.network,
    user: store.user,
  }));

  const { isLoading, mutate } = useLoadAirdrops();

  const airdrops = useAirdrops((store) => store.airdrops[currentNetwork]);
  const airdropsArray = Object.values(airdrops ?? {});
  const sortedAirdropsArray = airdropsArray.sort((a, b) => {
    const statusAIndex = statusOrder.indexOf(a.status);
    const statusBIndex = statusOrder.indexOf(b.status);
    return statusAIndex - statusBIndex;
  });

  const isUserHaveNFT = user.networksData[currentNetwork].nft?.array.length ?? 0;

  return (
    <styles.Container>
      <Header />
      <Networks />
      <styles.Title>{t("Airdrop.Title")}</styles.Title>

      {isLoading ? (
        <styles.StyledLoading />
      ) : airdropsArray.length && isUserHaveNFT > 0 ? (
        <>
          <ScrollSnapping
            array={sortedAirdropsArray}
            component={(airdrop) => <Airdrop key={airdrop.id} {...airdrop} mutateAirdrops={mutate} />}
          />
        </>
      ) : (
        <EmptyNFTs />
      )}
    </styles.Container>
  );
};
